<template>
  <v-select
    label="Work Views"
    v-model="selectedView"
    :items="views"
    item-text="name"
    return-object
    @change="setWorkView"
    clearable
  ></v-select>
</template>

<script>
export default {
  props: ["columns"],
  data() {
    return {
      selectedView: null,
      views: [
        {
          id: "expiringPlans",
          name: "Expiring Plans",
          display: this.columns.filter((x) =>
            x.workviewTags.includes("#expiring")
          ),
        },
        {
          id: "pendingAssignment",
          name: "Pending Provider Assignment",
          display: this.columns.filter((x) =>
            x.workviewTags.includes("#pendingAssignment")
          ),
        },
        {
          id: "pendingApproval",
          name: "Pending Assignment Approval",
          display: this.columns.filter((x) =>
            x.workviewTags.includes("#pendingApproval")
          ),
        },
        {
          id: "awaitingFADSubmission",
          name: "Awaiting FAD Submission",
          display: this.columns.filter((x) =>
            x.workviewTags.includes("#awaitingFADSubmission")
          ),
        },
      ],
    };
  },
  methods: {
    setWorkView() {
      if (this.selectedView == null) {
        this.$store.dispatch(
          "plansModule/setDisplayColumns",
          this.columns.map((x) => x.value)
        );
        this.$store.dispatch("plansModule/clearWorkview");
      } else {
        this.$store.dispatch(
          "plansModule/setDisplayColumns",
          this.selectedView.display.map((x) => x.value)
        );
        this.$store.dispatch("plansModule/setWorkview", this.selectedView.id);
      }
    },
  },
};
</script>